/* Main Menu */
var $ = jQuery.noConflict();

$(function () {
    // Close mobile submenu
    $(".mobile-menu-back").on("click", function () {
        $(this).parent().removeClass("show");
    });
});

("use strict");

////////////////////////////////////////////////
// START -  mobile nav toggle JS
// var navbarToggler = document.querySelector('.navbar-toggler');
// var navbarBg = document.querySelector( '.navbar-bg' );
// var navBar = document.querySelector( '.navbar' );
// var ariaExpanded = navbarToggler.getAttribute( 'aria-expanded' );

// navbarToggler.addEventListener( 'click' , function() {

//     navBar.classList.toggle( 'is-active' );

//     if (ariaExpanded == 'true' ) {
//         ariaExpanded = 'false'
//     } else {
//         ariaExpanded = 'true'
//     }
//     navbarToggler.setAttribute( 'aria-expanded' , ariaExpanded);
// });
// END - mobile nav toggle JS
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - remove load class from body
$(window).on("load", function () {
    // When the page has loaded
    $("body").removeClass("page-loading");

    // Toggle the mobile filters menu
    $("[data-trigger-filters]").on("click", function () {
        $(".filters-wrap").toggleClass("filters-open");
        $(".filters-wrap .filter").toggleClass("mobile-show");
    });
});
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - only show focus ring on tab not click
function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("user-is-tabbing");
        window.removeEventListener("keydown", handleFirstTab);
        window.addEventListener("mousedown", handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing");
    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);
// END - only show focus ring on tab not click
///////////////////////////////////////////////

////////////////////////////////////////////////
// START - Custom dropdown functionality for filters
////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
    // Select all dropdown elements
    const dropdowns = document.querySelectorAll(".filters-dropdown");

    dropdowns.forEach((dropdown) => {
        const button = dropdown.querySelector(".filters-dropdown__toggle");
        const menu = dropdown.querySelector(".dropdown-menu");
        const checkboxes = menu.querySelectorAll('input[type="checkbox"]');

        // Handle Bootstrap dropdown events
        dropdown.addEventListener("show.bs.dropdown", function () {
            button.setAttribute("aria-expanded", "true");
        });

        dropdown.addEventListener("hide.bs.dropdown", function () {
            button.setAttribute("aria-expanded", "false");
        });

        // Prevent dropdown from closing when clicking inside
        menu.addEventListener("click", function (e) {
            e.stopPropagation();
        });

        // Update button text when checkboxes change
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", function (e) {
                e.stopPropagation();
                updateButtonText(dropdown);
            });
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", function (e) {
            if (!dropdown.contains(e.target)) {
                const dropdownInstance = bootstrap.Dropdown.getInstance(button);
                if (dropdownInstance) {
                    dropdownInstance.hide();
                }
            }
        });
    });

    /**
     * Update the button text based on selected checkboxes
     * @param {HTMLElement} dropdown - The dropdown element
     */
    function updateButtonText(dropdown) {
        const button = dropdown.querySelector(".filters-dropdown__toggle");
        const buttonText = button.getAttribute("data-default-text");
        const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]:checked');
        const span = button.querySelector("span");

        if (checkboxes.length > 0) {
            span.textContent = `${checkboxes.length} Selected`;
        } else {
            if (buttonText && "" !== buttonText) {
                span.textContent = buttonText;
            } else {
                span.textContent = "Please select";
            }
        }
    }
});

////////////////////////////////////////////////
// END - Custom dropdown functionality for filters
////////////////////////////////////////////////

// Close primary navigation when clicking outside of the menu
$(document).click(function (e) {
    // Only needed for larger screens
    if ($(window).width() >= 1200) {
        // Element to exclude/s. When clicked this element/s won't close the dropdown
        if (!$(e.target).is(".desktop-menu__col a span, .header-search input")) {
            $(".collapse").collapse("hide");
        }
    }
});

////////////////////////////////////////////////
// START -  Add 'active' class to dropdown button if any child link is active
////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
    const dropdowns = document.querySelectorAll(".desktop-menu__collapse");

    dropdowns.forEach(function (dropdown) {
        const activeLink = dropdown.querySelector(".desktop-menu__link.active");
        if (activeLink) {
            const dropdownButton = dropdown.previousElementSibling;
            if (dropdownButton && dropdownButton.classList.contains("desktop-menu__btn")) {
                dropdownButton.classList.add("active");
            }
        }
    });
});
////////////////////////////////////////////////
// END - Add 'active' class to dropdown button if any child link is active
////////////////////////////////////////////////

////////////////////////////////////////////////
// START - Show the top/bottom fades on dropdowns that can scroll that way
////////////////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".desktop-menu__collapse-inner").forEach(function (inner) {
        const updateFades = function () {
            inner.parentElement.classList.toggle("is-scrolled", inner.scrollTop > 0);
            inner.parentElement.classList.toggle("has-more", inner.scrollTop + inner.clientHeight < inner.scrollHeight - 1);
        };
        inner.addEventListener("scroll", updateFades, { passive: true });
        inner.closest(".desktop-menu__collapse").addEventListener("shown.bs.collapse", updateFades);
        window.addEventListener("resize", updateFades);
    });
});
////////////////////////////////////////////////
// END - Show the top/bottom fades on dropdowns that can scroll that way
////////////////////////////////////////////////

////////////////////////////////////////////////
// START - Smooth Scroll To
////////////////////////////////////////////////
$(document).ready(function () {
    $("[data-scroll-to]").click(function () {
        const target = $(this).data("scroll-to");
        let offset = 82;

        if ($("body").hasClass("admin-bar")) {
            const admin_bar_height = $("#wpadminbar").height();
            offset = offset + admin_bar_height;
        }

        $("html, body").animate(
            {
                scrollTop: $(target).offset().top - offset,
            },
            1000
        );
    });
});
////////////////////////////////////////////////
// END - Smooth Scroll To
////////////////////////////////////////////////
